const menuRouter = [
    /**
     * 系统管理
     **/
    {
        path: '/supplier/supplier',
        meta: { title: '供应商添加' },
        component: () => import('@/views/page/supplier/supplier'),
        used: true,
    },
    {
        path: '/supplier/appraise',
        meta: { title: '供应商考核' },
        component: () => import('@/views/page/supplier/appraise'),
        used: true,
    },
    {
        path: '/supplier/check',
        meta: { title: '供应商评分' },
        component: () => import('@/views/page/supplier/check'),
        used: true,
    },
    {
        path: '/supplier/change',
        meta: { title: '供应商信息变更' },
        component: () => import('@/views/page/supplier/change'),
        used: true,
    }
]

export default menuRouter
